import React, { Fragment } from "react";
import { Field, useForm } from "react-final-form";
import { FormGroup, Label, Col } from "reactstrap";

import { InputField, ToggleField, CreatableMultiselect, ReactSelect, required, isNotEmpty } from "modules/4_final_form/web";
import { OnChange } from "react-final-form-listeners";

import { SmartSelect } from "modules/4_final_form/mobile";
import _ from "lodash";

export const MultiSelectFieldAttributes = ({ fieldName, namesUsed }) => {
  const form = useForm();

  return (
    <Fragment>
      <FormGroup row>
        <Label md={3}>Label</Label>
        <Col md={8}>
          <Field name={`${fieldName}.label`} component={InputField} />
          <OnChange name={`${fieldName}.label`}>
            {(value, previous) => {
              if (value) {
                let name = _.snakeCase(value);
                // Check first character is a number
                if (name.match(/^\d/)) {
                  name = `_${name}`;
                }
                form.change(`${fieldName}.name`, name);
              }
            }}
          </OnChange>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Name</Label>
        <Col md={8}>
          <Field
            name={`${fieldName}.name`}
            component={InputField}
            validate={(value, values) => {
              if (!value) {
                return "is required";
              }
              if (namesUsed.includes(value)) {
                return "must be unique";
              }
            }}
            convertToLowerCase
            lettersOnly
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Placeholder</Label>
        <Col md={8}>
          <Field name={`${fieldName}.placeholder`} component={InputField} />
        </Col>
      </FormGroup>
      <hr />
      <FormGroup row>
        <Label md={3}>Select Options</Label>
        <Col md={8}>
          <Field name={`${fieldName}.options`} component={CreatableMultiselect} />
        </Col>
      </FormGroup>

      {/* <FormGroup row>
        <Label md={3}>Multi Select</Label>
        <Col md={8}>
          <Field name={`${fieldName}.multi_select`} component={ToggleField} />
        </Col>
      </FormGroup> */}
      <hr />
      <FormGroup row>
        <Label md={3}>Required Field</Label>
        <Col md={8}>
          <Field name={`${fieldName}.required`} component={ToggleField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>On Dashboard</Label>
        <Col md={8}>
          <Field name={`${fieldName}.on_dashboard`} component={ToggleField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>On Report</Label>
        <Col md={8}>
          <Field name={`${fieldName}.on_report`} component={ToggleField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Mobile Select Type</Label>
        <Col md={8}>
          <Field
            name={`${fieldName}.mobile_select_type`}
            component={ReactSelect}
            options={[
              { value: "page", label: "Page" },
              { value: "popup", label: "Popup" },
              { value: "popover", label: "Popover" },
              { value: "sheet", label: "Sheet" },
            ]}
            validate={required}
          />
        </Col>
      </FormGroup>
    </Fragment>
  );
};

export const MultiSelectFieldForm = (props) => {
  const { label, placeholder, required: isRequired, preview, name, prefixName, options } = props;

  const newOptions = _.map(options, (option) => _.omit(option, "__isNew__"));

  return (
    <FormGroup row>
      {label && (
        <Label md={2}>
          {label}
          {isRequired && "*"}
        </Label>
      )}
      <Col md={8}>
        <Field
          name={`${prefixName}.${name}`}
          disabled={preview}
          component={ReactSelect}
          multi
          options={newOptions}
          placeholder={placeholder}
          validate={isRequired && !preview ? isNotEmpty : null}
        />
      </Col>
    </FormGroup>
  );
};

MultiSelectFieldForm.defaultProps = {
  prefixName: "data",
};

export const MobileMultiSelectFieldForm = (props) => {
  const { label, placeholder, required: isRequired, preview, name, prefixName, options, mobile_select_type } = props;
  const newOptions = _.map(options, (option) => _.omit(option, "__isNew__"));

  return (
    <Field
      name={`${prefixName}.${name}`}
      label={label}
      disabled={preview}
      component={SmartSelect}
      options={newOptions}
      placeholder={placeholder}
      validate={isRequired && !preview ? isNotEmpty : null}
      valueName="value"
      labelName="label"
      openIn={mobile_select_type}
      multi
      style={{ backgroundColor: "rgb(225, 226, 236)", margin: "12px", borderBottom: "1px solid" }}
    />
  );
};

MobileMultiSelectFieldForm.defaultProps = {
  prefixName: "data",
};
